import React from "react";
import { useBilling } from "../../../../contexts/api/billing";
import type { Product, ProductRequest } from "../../../../api/billing/Billing.typed";

export default function useProducts() {
  const { listProducts, createProduct, updateProduct, deleteProduct } = useBilling();
  const [products, setProducts] = React.useState<Product[]>([]);
  const [loading, setLoading] = React.useState(true);

  const reload = React.useCallback(async () => {
    setLoading(true);
    const data = await listProducts();
    if (data) setProducts(data);
    setLoading(false);
  }, [listProducts]);

  React.useEffect(() => {
    reload();
  }, [reload]);

  const create = React.useCallback(
    async (req: ProductRequest) => {
      const created = await createProduct(req);
      if (created) setProducts((prev) => [...prev, created]);
      return created;
    },
    [createProduct],
  );

  const update = React.useCallback(
    async (id: number, req: ProductRequest) => {
      const updated = await updateProduct(id, req);
      if (updated) setProducts((prev) => prev.map((p) => (p.ID === id ? updated : p)));
      return updated;
    },
    [updateProduct],
  );

  const remove = React.useCallback(
    async (id: number) => {
      const ok = await deleteProduct(id);
      if (ok) setProducts((prev) => prev.filter((p) => p.ID !== id));
    },
    [deleteProduct],
  );

  return { products, loading, reload, create, update, remove };
}
